<template>
  <div>
    <div class="page-title">New Presentation</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Presentation"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.presentations.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Presentation",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Presentation.new();
      this.form = data;
    },
    async create() {
      await this.$api.Presentation.create(this.form);
      this.$router.push("/dev-tools/presentations");
    },
  },
};
</script>

<style></style>
